import "./styles.css";
import Blog from "./components/Blog";
export default function App() {
  return (
    <div className="App">
      <Blog />
    </div>
  );
}
